import { MatomoSources } from '@/matomo/events/MatomoSources';
import MatomoSourceService from '@/services/matomo/MatomoSourceService';

export default class MatomoContext {
  public readonly source?: string;

  private static readonly matomoService = MatomoSourceService.singleton();

  private constructor(source: string) {
    this.source = source;
  }

  public static default(): MatomoContext {
    return new MatomoContext(null);
  }

  public static forRecommendedProducts(title: string): MatomoContext {
    return new MatomoContext(title);
  }

  public static forProductListItem(isPromoted: boolean): MatomoContext {
    const matomoSource = this.matomoService.getMatomoSourceOfPage();
    if (!matomoSource) {
      return MatomoContext.default();
    }

    if (isPromoted) {
      return new MatomoContext(matomoSource + ' Promotion');
    }

    return new MatomoContext(matomoSource);
  }

  public static forCartPage(): MatomoContext {
    return new MatomoContext(MatomoSources.CART);
  }

  public static forProductDetail(): MatomoContext {
    return new MatomoContext(MatomoSources.PRODUCT_DETAIL);
  }

  public hasSource(): boolean {
    return !!this.source;
  }

}
